const React = require('react')
const Outter = require('./src/layout/templates/Outter/index.js').default

exports.wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Outter {...props}>{element}</Outter>
}
